import { useState, useRef } from 'react'
import {
  faqImages,
  images,
} from '../../services/images.service'
import { FAQHelmet } from '../../cmps/Helments/FAQHelmet';
import { MinusIcon, PlusIcon } from '../../cmps/ui/icons/shared';

// נתוני השאלות לפי קטגוריות
const faqData = {
  beginners: [
    {
      id: 1,
      question: 'מהי אנימה (Anime)?',
      answer:
        'אנימה היא סגנון אנימציה יפני המתאפיין בסגנון ציור ייחודי, עם דגש על הבעות פנים גדולות וצבעוניות. אנימה מכסה מגוון רחב של ז’אנרים, כגון פעולה, דרמה, פנטזיה, מדע בדיוני ורומנטיקה. רוב האנימות מבוססות על מנגה, אך יש גם אנימות מקוריות או כאלה המבוססות על לייט נובלים.',
    },
    {
      id: 2,
      question: 'מהי מנגה (Manga)?',
      answer:
        "מנגה היא קומיקס יפני, בדרך כלל בשחור-לבן, שנקרא מימין לשמאל. אנימות רבות מופקות על בסיס המנגה. הצ’אפטרים (פרקים) במנגה יוצאים לרוב במגזינים (שבועיים או חודשיים), ולאחר מכן נאספים ל'ווליום' (כרך).",
    },
    {
      id: 3,
      question: 'מה ההבדל בין אנימה למנגה?',
      answer:
        "• **פורמט** – אנימה לצפייה (אנימציה), מנגה לקריאה (קומיקס).\n• **עלילה** – במנגה זו 'הגרסה המקורית', באנימה עלולים להיות שינויים או פרקי פילר.\n• **קצב** – באנימה צופים בקצב השידור, בעוד במנגה קוראים בקצב אישי.\n• **אמנות** – מנגה מתמקדת באיורים ובלוני טקסט; אנימה מוסיפה צבע, תנועה וסאונד.",
    },
    {
      id: 4,
      question: "מה זה צ'אפטר (Chapter)?",
      answer:
        'צ’אפטר הוא פרק בודד של מנגה, המתפרסם בדרך כלל במגזינים יפניים (למשל Weekly Shonen Jump). לאחר מספר צ’אפטרים, הם נאספים ומודפסים ביחד בווליום (כרך).',
    },
    {
      id: 5,
      question: 'מה זה ווליום (Volume)?',
      answer:
        'ווליום הוא כרך המאגד כמה צ’אפטרים רצופים של אותה מנגה (לרוב 4–10 צ’אפטרים). הוא יוצא לאור לאחר שהצ’אפטרים כבר פורסמו בנפרד במגזין.',
    },
    {
      id: 6,
      question: 'מה זה סאגה (Saga)?',
      answer:
        'בסדרות ארוכות נהוג לחלק את העלילה לארקים (Arcs) – קשת עלילתית מוגדרת. **סאגה** (Saga) היא קבוצה של ארקים שמרכיבים סיפור-על רחב יותר. לא כל סדרה משתמשת במונח הזה, והוא נפוץ במיוחד בסדרות כמו *One Piece* ו-*Dragon Ball*.',
    },
    {
      id: 7,
      question: 'באילו עונות יוצאות אנימות חדשות?',
      answer:
        "ביפן נהוגות ארבע 'עונות שידור' עיקריות:\n• **חורף (Winter)** – מתחילה בינואר\n• **אביב (Spring)** – מתחילה באפריל\n• **קיץ (Summer)** – מתחילה ביולי\n• **סתיו (Fall)** – מתחילה באוקטובר\nבכל עונה עולות סדרות חדשות או עונות המשך.",
    },
    {
      id: 8,
      question: 'באילו עונות יוצאות מנגות חדשות?',
      answer:
        "מנגות אינן פועלות במודל 'עונתי' כמו אנימה. הן מתפרסמות באופן שוטף (שבועי או חודשי). צ’אפטרים יוצאים בקביעות במגזינים, ובהמשך נאספים לווליומים. לעיתים ווליומים מושקים סביב חופשות (קיץ/חורף) לצורכי שיווק.",
    },
    {
      id: 9,
      question: 'איך מתחילים לקרוא מנגה או לצפות באנימה בפעם הראשונה?',
      answer:
        "1. **בחר ז’אנר מועדף** (אקשן, קומדיה, פנטזיה וכו’).\n2. **התחל עם סדרות מוכרות** (למשל 'Naruto' או 'Attack on Titan').\n3. **התייעץ עם חברים או בפורומים / אתרי דירוג** (כמו MyAnimeList).\n4. **החליט אם אתה מעדיף לקרוא (מנגה) או לצפות (אנימה) כשלב ראשון.**",
    },
    {
      id: 10,
      question: 'האם כל האנימות מתאימות לכל הגילאים?',
      answer:
        "לא. כמו בסרטים, יש דירוג גיל. חלק מהסדרות ידידותיות לילדים (למשל 'פוקימון'), וחלק מכילות תכנים בוגרים או אלימים ('Attack on Titan', 'Death Note'). מומלץ לבדוק דירוגים והמלצות לפני הצפייה.",
    },
    {
      id: 11,
      question: 'האם יש ז’אנרים שונים באנימה, בדומה לסרטים מערביים?',
      answer:
        'בהחלט. קיימים ז’אנרים כמו שונן (Shounen, אקשן לנוער), שוג’ו (Shoujo, רומנטיקה לנערות), סיינן (Seinen, לקהל בוגר יותר), קומדיה, אימה, ספורט ועוד.',
    },
    {
      id: 12,
      question: 'מה זה סאב (Sub) ומה זה דאב (Dub) באנימה?',
      answer:
        '• **Sub** – אנימה ביפנית עם כתוביות (באנגלית/שפה אחרת).\n• **Dub** – אנימה מדובבת לשפה אחרת (למשל אנגלית), כך שאין צורך בכתוביות.',
    },
    {
      id: 13,
      question: 'מהם אתרי הזרמת אנימה פופולריים וכיצד מוצאים אנימות לצפייה?',
      answer:
        'פלטפורמות כמו Crunchyroll, Funimation, Netflix (חלק מהמגוון), Amazon Prime Video ועוד. ניתן לחפש לפי דירוגים והמלצות ב-MyAnimeList או בפורומים ייעודיים.',
    },
    {
      id: 14,
      question: 'איך מזהים מדבב מפורסם (Seiyuu) בסדרה?',
      answer:
        'ביפן, מדבבים (Seiyuu) נחשבים סלבריטאים. אפשר לבדוק בקרדיטים של הפרק, באתרי מידע (MyAnimeList, Anime News Network) או לזהות את הקול אם מכירים את המדבב.',
    },
    {
      id: 15,
      question: 'אילו אנימות מומלצות למתחילים?',
      answer:
        "סדרות כמו 'Fullmetal Alchemist: Brotherhood', 'My Hero Academia' ו-'Attack on Titan' נחשבות נוחות למתחילים: עלילה ברורה, אנימציה איכותית ודמויות שקל להתחבר אליהן.",
    },
    {
      id: 16,
      question:
        'מה זה Anime Opening (שיר פתיחה) ו-Anime Ending (שיר סיום), ולמה מחליפים אותם לפעמים בעונה חדשה?',
      answer:
        'לכל אנימה יש שיר פתיחה וסיום שמייצגים את הסגנון שלה. לעיתים קרובות הם מתחלפים בעונה חדשה או בארק עלילתי חדש כדי לרענן את הסדרה ולשווק מוזיקה חדשה.',
    },
    {
      id: 17,
      question: 'איך מודדים פופולריות של אנימה בקהילה העולמית?',
      answer:
        'מסתכלים על דירוגי אתרים (כמו MyAnimeList), מספר הצפיות בשירותי סטרימינג (כמו Netflix, Crunchyroll), מכירות DVD/Blu-ray ומידת העיסוק ברשתות חברתיות.',
    },
    {
      id: 18,
      question: "מהי משמעות המילה 'מנגה-קא' (Mangaka)?",
      answer:
        'מנגה-קא הוא יוצר המנגה – אחראי הן על כתיבת התסריט והן על איור הציורים (לעיתים יחד עם עוזרים). בניגוד למודל המערבי, לרוב מדובר ביוצר יחיד שמוביל את כל התהליך.',
    },
    {
      id: 19,
      question:
        'מדוע חלק מהדמויות באנימה מופיעות עם שיער בצבעים מיוחדים (ורוד, ירוק, כחול וכדומה)?',
      answer:
        'כדי להבליט אופי או תכונות אופי של דמות, וגם כדי להבדיל בקלות בין דמויות רבות. צבעי שיער ייחודיים הם אלמנט צורני מקובל בסגנון האנימה.',
    },
    {
      id: 20,
      question: 'מה זה OST (Original Soundtrack) באנימה?',
      answer:
        'זהו פסקול מקורי שנכתב במיוחד עבור הסדרה, כולל מנגינות רקע, נעימות פתיחה וסיום, וקטעים שמביעים רגשות או אווירה בזמן הפרקים.',
    },
    {
      id: 21,
      question:
        'איך מזהים אנימה שמיועדת לילדים לעומת אנימה שמיועדת לנוער/מבוגרים?',
      answer:
        "אנימה לילדים משודרת לרוב בשעות הבוקר-צהריים, עם עלילות פשוטות ותוכן 'רגוע'. אנימה לנוער או מבוגרים משודרת בשעות מאוחרות, עם תכנים בוגרים יותר או אלימות מוגברת.",
    },
    {
      id: 22,
      question: 'מה ההבדל בין סרט אנימה לסדרת אנימה מבחינת הפקה?',
      answer:
        'סרט אנימה הוא פרויקט חד-פעמי באורך מלא (לרוב 1.5–2 שעות) עם תקציב גבוה יותר ואנימציה מושקעת. סדרת אנימה משודרת בפרקים של כ-24 דקות, והתקציב מתחלק על פני עונה שלמה.',
    },
    {
      id: 23,
      question: "מהו 'סרט מסכם' (Movie Compilation) על בסיס סדרת אנימה?",
      answer:
        'זהו סרט שקולע לעיקרי העלילה של הסדרה, לעיתים עם סצנות נוספות/חדשות, כדי לצפות בצורה מקוצרת. מתאים למי שרוצה רענון מהיר או הכנה להמשך העלילה.',
    },
    {
      id: 24,
      question: 'מה זה אנימת Late-Night לעומת אנימה שמשודרת בצהריים?',
      answer:
        'אנימת Late-Night משודרת בלילה (לרוב לקהל מבוגר יותר, עם תכנים בוגרים, אלימים או מורכבים). אנימת צהריים (Kids/Family) פונה לגיל צעיר או לצפייה משפחתית.',
    },
    {
      id: 25,
      question: 'מהן הדרכים הנפוצות לצפות באנימה בישראל באופן חוקי?',
      answer:
        'חלק מהסדרות זמינות ב-Netflix, Amazon Prime Video, ובין היתר ב-Crunchyroll (לעיתים דרך VPN). לעיתים יש תרגום לעברית או לאנגלית.',
    },
    {
      id: 26,
      question: 'האם חייבים לדעת יפנית כדי ליהנות מאנימה?',
      answer:
        'לא. יש כתוביות (Sub) או דיבוב (Dub) לשפות רבות. מי שמבין יפנית נהנה אולי מניואנסים נוספים, אבל ממש לא חובה לשליטה בסיסית בתוכן.',
    },
    {
      id: 27,
      question: "מהי 'אנימת מג’יקל גירל' (Magical Girl), ולמי היא מיועדת?",
      answer:
        "ז’אנר בו בנות (נערות צעירות) מקבלות כוחות קסם, עם טרנספורמציות ותלבושות ססגוניות (למשל 'Sailor Moon'). לרוב מכוון לנערות, אך מושך גם מבוגרים בזכות הנוסטלגיה והפנטזיה.",
    },
    {
      id: 28,
      question: 'מה זה אומקה (Omake) בסיום פרקים של אנימה או בסוף ווליום מנגה?',
      answer:
        'אומקה הוא קטע בונוס משעשע או סקיצה קצרה המופיעה בסיום. לפעמים כוללת בדיחות פנימיות, סצנות קלילות או אינפורמציה נוספת על הדמויות.',
    },
    {
      id: 29,
      question: 'כיצד לבחור אנימה ראשונה למי שלא צפה מעולם?',
      answer:
        'כדאי לברר אילו ז’אנרים אותו אדם אוהב (אקשן, ספורט, רומנטיקה וכו’), ולהציע סדרה קצרה יחסית, בעלילה מובנת בלי יותר מדי פילרים או בדיחות פנימיות.',
    },
    {
      id: 30,
      question: "מהו 'סימולקאסט' (Simulcast) באנימה, ולמה הוא חשוב?",
      answer:
        'סימולקאסט הוא שידור בו-זמני (או כמעט בו-זמני) של אנימה מחוץ ליפן, כשיש כתוביות מוכנות מראש. הוא מצמצם פיראטיות ומאפשר למעריצים בינלאומיים לחוות יחד את הפרקים החדשים.',
    },
    {
      id: 31,
      question: "האם סדרות כמו 'פוקימון' ו'יוגיהו' נחשבות לאנימה?",
      answer:
        'כן. אלו הפקות אנימציה יפניות, מבוססות לרוב על משחקים/מותגים יפניים, והן עומדות תחת ההגדרה הכוללת של אנימה.',
    },
    {
      id: 32,
      question: 'איך הרשתות החברתיות משפיעות על התפוצה של אנימה בקרב מתחילים?',
      answer:
        'אנשים משתפים המלצות, סצנות, וקטעי וידאו, מה שיוצר עניין בינלאומי. כך סדרות חדשות (או וותיקות) צוברות מעריצים חדשים שאולי לא הכירו אנימה קודם.',
    },
    {
      id: 33,
      question: "מה זה 'Long Running Anime' ולמה היא מרתיעה חלק מהמתחילים?",
      answer:
        "סדרה בעלת עשרות או מאות פרקים (כגון 'One Piece'). ההשקעה הנדרשת גדולה, ויש גם לא מעט פרקי פילר. מתחילים מעדיפים לעיתים סדרות קצרות יותר.",
    },
    {
      id: 34,
      question:
        'אילו טקסי פרסים קיימים בעולם האנימה, והאם הם משפיעים על בחירת סדרות חדשות?',
      answer:
        'ישנם פרסים כמו Crunchyroll Anime Awards או Tokyo Anime Award Festival. זכייה או מועמדות יכולה להעלות את פרופיל הסדרה ולהמריץ השקעות בעונות המשך או הפקות נוספות.',
    },
    {
      id: 35,
      question:
        "מה ההבדל בין האנימה היפנית המקורית לבין סדרות מערביות שמאמצות סגנון 'אנימה' (כמו 'Avatar: The Last Airbender')?",
      answer:
        'אנימה יפנית מופקת ביפן, בד"כ בשפה היפנית ומבוססת על מנגה/לייט נובל. סדרות מערביות מאמצות רק את הסגנון הוויזואלי, מופקות מחוץ ליפן, ולרוב אינן משויכות לתעשיית המנגה היפנית המסורתית.',
    },
  ],

  advanced: [
    {
      id: 1,
      question: 'מה זה לייט נובל (Light Novel)?',
      answer:
        'לייט נובל הוא ספר או סדרת ספרים יפניים, המתאפיינים בטקסט קליל ובכמה איורים. אנימות רבות מבוססות על לייט נובלים. ההבדל המרכזי ממנגה הוא שהעלילה מוצגת בעיקר בכתב עם איורים בודדים, ולא בצורת קומיקס.',
    },
    {
      id: 2,
      question: 'מה זה אובה (OVA) ואונליין סטרימינג של אנימה (ONA)?',
      answer:
        'OVA (Original Video Animation) – פרקים/ספיישלים אנימטיביים שנמכרים ישירות ב-DVD/בלו-ריי, ולא תמיד משודרים בטלוויזיה. ONA (Original Net Animation) – אנימה המשוחררת ברשת בלבד (סטרימינג), ללא ערוץ טלוויזיה או מוצר פיזי.',
    },
    {
      id: 3,
      question:
        'מה ההבדל בין שונן (Shounen), שוג’ו (Shoujo), סיינן (Seinen) וג’וסיי (Josei)?',
      answer:
        'אלו קטגוריות לפי קהל יעד: * שונן – לנערים צעירים (אקשן, הרפתקאות). * שוג’ו – לנערות צעירות (רומנטיקה, מערכות יחסים). * סיינן – לבוגרים (גברים), עם תכנים יותר מורכבים/אפלים. * ג’וסיי – לנשים בוגרות, מתמקד בעלילות בוגרות ורגשיות.',
    },
    {
      id: 4,
      question: 'מה זה פילרים (Filler) באנימה?',
      answer:
        'פרקים או ארקים שאינם מבוססים על המנגה המקורית, ונוספו על ידי צוות האנימה כדי להימנע מהגעה מהירה מדי לחומרי המקור. פילרים יכולים להוסיף הרחבה לדמויות, אך לעיתים גורמים להאטה בקצב העלילה.',
    },
    {
      id: 5,
      question:
        'איך להבדיל בין גרסאות שונות של אותה אנימה (כגון “Hunter x Hunter 1999” ו-“Hunter x Hunter 2011”)?',
      answer:
        'לפעמים מפיקים רימייק כדי להתקרב יותר למנגה או לשפר אנימציה. השנה שמצורפת לשם הסדרה מציינת את שנת ההפקה. גרסה חדשה עשויה לכלול שינויים מהותיים או אדפטציה מלאה יותר.',
    },
    {
      id: 6,
      question: "מהו 'שיפינג' (Shipping) בקהילת האנימה והמנגה?",
      answer:
        '‘שיפינג’ מתייחס לרצון של המעריצים לראות דמויות מסוימות מתפתחות לזוג רומנטי (או קשר אחר). מתבטא בפאנארטים, פאנפיקים, דיונים ברשת ועוד.',
    },
    {
      id: 7,
      question: 'איך מגלים אם מנגה מסוימת תורגמה לשפות אחרות?',
      answer:
        'בודקים באתרי הוצאות לאור רשמיים (VIZ, Kodansha, Seven Seas) או בחנויות אונליין (Amazon, Book Depository). אתרי מידע כמו MyAnimeList מציינים לעיתים גם הוצאות בשפות זרות.',
    },
    {
      id: 8,
      question: 'מה זה ספין-אוף (Spin-off) בעולם האנימה והמנגה?',
      answer:
        'ספין-אוף הוא סיפור צדדי שמתרחש באותו עולם עלילתי, אך מת聚קד בדמויות אחרות או בעלילה משנית. לעיתים מרחיב רקע לדמויות או מראה עלילות מקבילות.',
    },
    {
      id: 9,
      question: 'האם יש הבדל בין מנגה מודפסת למנגה דיגיטלית?',
      answer:
        'לרוב התוכן זהה, אך גרסה מודפסת היא פיזית ונאספת על-ידי אספנים, בעוד גרסה דיגיטלית נקראת דרך אתרים ואפליקציות. דיגיטלי נוח וזול יותר, אך חסר את ההנאה מאיסוף והחזקה פיזית.',
    },
    {
      id: 10,
      question: 'מהן תצורות השידור הנפוצות באנימה (12-13 פרקים מול 24-26)?',
      answer:
        "סדרות רבות משודרות בפורמט 'Cour' של 12–13 פרקים. אחרות משודרות 24–26 פרקים בעונה ארוכה יותר. לעיתים רחוקות יש גם סדרות רצות ללא הגבלת עונה (כמו 'One Piece').",
    },
    {
      id: 11,
      question: "מהו 'דוג’ינשי' (Doujinshi), וכיצד הוא מתקשר לקהילת המעריצים?",
      answer:
        'דוג’ינשי הם קומיקסים עצמאיים שיוצרים חובבים על בסיס מנגות/אנימות מוכרות (או רעיונות מקוריים). הם נמכרים באירועים כמו Comiket ויכולים לכלול עלילות משלהם או גרסאות אלטרנטיביות.',
    },
    {
      id: 12,
      question:
        'איך פרסי מנגה (כמו Kodansha Manga Awards) עשויים להשפיע על הפיכת המנגה לאנימה?',
      answer:
        'זכייה או מועמדות לפרס יוקרתי מעלה את פרופיל המנגה בעיני מפיקים וסטודיואים. כך גדל הסיכוי לקבל עיבוד אנימה, בזכות הבאזז התקשורתי.',
    },
    {
      id: 13,
      question:
        'מהו אירוע קרוס-אובר (Cross Over) בין מנגות או אנימות, ואיך הוא משפיע על הקהל?',
      answer:
        'קרוס-אובר מאחד שתי סדרות שונות לסיפור אחד (או פרק מיוחד). זה יוצר התלהבות ומושך מעריצים משני העולמות, שצופים בשיתוף הפעולה הייחודי.',
    },
    {
      id: 14,
      question: "מהן אנימות 'אנתולוגיה' וכיצד הן שונות מסדרות עלילתיות רגילות?",
      answer:
        'אנתולוגיה היא אוסף סיפורים קצרים תחת נושא משותף, לעיתים ללא עלילה מתמשכת. לעומת סדרות נרטיביות, כל פרק עשוי להיות סיפור עצמאי עם צוות יוצרים שונה.',
    },
    {
      id: 15,
      question:
        "האם יש אנימות שמייצרות מראש סוף שונה מהמנגה ('Original Ending')?",
      answer:
        "כן. קורה שהאנימה 'משיגה' את המנגה או שהיוצר/המפיקים מעדיפים לסיים אחרת. כך נוצר סוף ייחודי לאנימה, שאינו תואם בהכרח את עלילת המנגה המקורית.",
    },
    {
      id: 16,
      question:
        'מהי הסיבה להבדלי איכות או עריכות חדשות בין גרסת השידור בטלוויזיה לבין גרסת ה-Blu-ray?',
      answer:
        'לגרסת הטלוויזיה יש דדליין צפוף, אז לפעמים לא מספיקים להשלים אנימציה או לתקן טעויות. בגרסת ה-Blu-ray משלימים ומשפרים סצנות, וכך מעודדים מעריצים לקנות את המוצר הפיזי.',
    },
    {
      id: 17,
      question:
        'מהם טרופים (Tropes) נפוצים באנימה, וכיצד הם משפיעים על המקוריות של הסדרה?',
      answer:
        "טרופים הם תבניות עלילתיות/עיצוביות נפוצות (למשל: 'הגיבור הנבחר', 'טורניר קרבות'). שימוש רב בטרופים עלול ליצור תחושה של חזרתיות, אך עיבוד יצירתי שלהם יכול להעשיר את הסיפור.",
    },
    {
      id: 18,
      question:
        "מהן 'אקשן פיגרס' (Action Figures) הקשורות לאנימה, וכיצד הן תורמות לפופולריות הסדרה?",
      answer:
        'אלו פסלונים או בובות של דמויות מהסדרה. הן נחשבות למרצ’נדייז רשמי, ומעריצים אוספים אותן בהתלהבות. מכירתן מגדילה את הרווחיות של הסדרה ומחזקת את מעמדה בשוק.',
    },
    {
      id: 19,
      question:
        'האם יש מנגות/אנימות היוצרות בכוונה סיפורים לא קאנוניים (Non-Canon)?',
      answer:
        'כן. לעיתים אלו ספיישלים או פילרים שאינם מופיעים במנגה. המטרה היא להוסיף תוכן, להרחיב דמויות, או לשמור על מרחק מהעלילה הראשית של המנגה.',
    },
    {
      id: 20,
      question:
        "מהו 'פריקוול' (Prequel) ו'סיקוול' (Sequel) בהקשר של אנימה ומנגה?",
      answer:
        'פריקוול מציג אירועים שקרו לפני קו העלילה המרכזי, וסיקוול מתרחש לאחר סיום הסיפור המקורי. שניהם מרחיבים את העולם והדמויות מחוץ לקו הזמן המקורי.',
    },
    {
      id: 21,
      question: "מהו 'Chapter Pilot' במנגה, וכיצד הוא משפיע על הפקת סדרה?",
      answer:
        'זהו צ’אפטר פיילוט המשוחרר כדי לבדוק תגובות הקהל. אם הוא זוכה לפופולריות, המו"ל מחליט להמשיכו כסדרה קבועה – ועם הזמן, ייתכן שיופק גם עיבוד לאנימה.',
    },
    {
      id: 22,
      question: 'איך מזהים שלסדרה יש עונה נוספת בפיתוח?',
      answer:
        "לעיתים מודיעים על כך רשמית בסיום הפרק האחרון ('To Be Continued'), או נוצרת הדלפה/פרסום במגזינים (למשל Weekly Shonen Jump). גם פרסום באירועי אנימה מעיד על כך.",
    },
    {
      id: 23,
      question:
        "מה זה 'רימייק' (Remake) באנימה, וכיצד הוא שונה מ'רי-מאסטר' (Remaster)?",
      answer:
        'רימייק הוא הפקה מחודשת מאפס – עלילה, אנימציה ואופי הסדרה עוברים התאמות או עדכונים. רי-מאסטר מתמקד בעיקר בשיפור איכות התמונה/סאונד של הגרסה הישנה, בלי לשנות את התוכן העלילתי.',
    },
    {
      id: 24,
      question:
        'מהי מדיניות המו"לים ביפן לגבי סריקות ותרגומים פיראטיים (Scanlations)?',
      answer:
        "באופן רשמי, הם נאבקים בזה משפטית בשל הפרת זכויות יוצרים. עם זאת, במקרים מסוימים זה מספק 'בדיקת שוק' לא רשמית שמעודדת הוצאות מתורגמות רשמיות כאשר מזהים ביקוש עולמי.",
    },
    {
      id: 25,
      question: "כיצד נוצר מצב שמנגה 'שונן' קצרה הופכת לאנימה ארוכה עם פילרים?",
      answer:
        "אם המנגה פופולרית מאוד, המפיקים רוצים להמשיך את האנימה בלי הפסקה. כשהעלילה המקורית לא מספיקה, מכניסים פילרים כדי 'למשוך זמן' עד שיצטבר חומר מקורי חדש במנגה.",
    },
    {
      id: 26,
      question:
        "מהי המשמעות של ז’אנר 'איסקאי' (Isekai) באנימה ומנגה, ולמה הוא כל כך פופולרי?",
      answer:
        "איסקאי מציג דמות ראשית המועברת לעולם פנטזיה/משחק/יקום אחר. הוא פופולרי כי הוא משלב הרפתקאות, כוח חדש וגילוי עולם לא מוכר. דוגמאות מוכרות הן 'Re:Zero' ו-'Sword Art Online'.",
    },
    {
      id: 27,
      question:
        "מהי המשמעות של המונח 'האנטאי' (Hentai) בתעשיית האנימה, ולמה חשוב להכיר אותו?",
      answer:
        "'האנטאי' הוא מונח לתכנים פורנוגרפיים או מיניים בוטים באנימה/מנגה. חשוב לדעת את ההגדרה כדי להימנע מחשיפה לא רצויה או בלתי הולמת לגילאים צעירים, ולכבד הגבלות צנזורה.",
    },
    {
      id: 28,
      question: "כיצד משתמשים במונח 'Headcanon' בקהילת המעריצים?",
      answer:
        "'Headcanon' הוא פרשנות אישית של מעריץ לאירועי העלילה או לדמויות, שאינה בהכרח קיימת באופן רשמי במנגה/אנימה. מעריצים נהנים לדון ולהציג השערות פרטיות על העולם הבדיוני.",
    },
    {
      id: 29,
      question: "מהו 'Oneshot' במנגה, וכיצד הוא שונה מסדרה רגילה?",
      answer:
        "'Oneshot' הוא סיפור קומיקס חד-פעמי, בדרך כלל קצר (צ’אפטר יחיד). אם הוא פופולרי, עשוי לקבל 'אור ירוק' להפוך לסדרת מנגה רגילה בהמשך.",
    },
    {
      id: 30,
      question:
        'כיצד משפיעות הכרזות על סרט קולנוע (Movie Announcement) על הצלחת אנימה?',
      answer:
        'הכרזה על סרט קולנוע מעידה בדרך כלל שהסדרה זכתה להצלחה רבה. זה מעלה את הפרופיל של הסדרה, מושך קהל חדש, ומאפשר להפקה תקציב גבוה יותר לשיפור איכות האנימציה והפיתוח.',
    },
    {
      id: 31,
      question: 'איך עובדת תעשיית האנימה ביפן מאחורי הקלעים?',
      answer:
        '* מפיקים – אחראים על מימון, חסויות ולוח זמנים.\n* סטודיו אנימציה – אמון על האנימציה, הבימוי, העיצוב והסאונד.\n* במאי – מתווה את הסגנון האמנותי והקצב העלילתי.\n* מדבבים (Seiyuu) – ביפן הם מפורסמים ותורמים לפופולריות הסדרה.\n* הפצה – משודרת בטלוויזיה או בשירותי סטרימינג, נמכרת בבלו-ריי ועוד.',
    },
    {
      id: 32,
      question: 'מדוע יש הבדלי איכות באנימציה בין פרקים שונים באותה עונה?',
      answer:
        '* צוותי אנימטורים שונים עם רמות מיומנות שונות.\n* לוחות זמנים דחוקים.\n* לעיתים משקיעים יותר אנימציה בפרקי שיא (קרבות גדולים), ופחות בפרקים של “בנייה עלילתית”.',
    },
    {
      id: 33,
      question: "מהי תופעת ה'סקלציה' (Scanlation) בעולם המנגה?",
      answer:
        'סריקה ותרגום לא-רשמי (פיראטי) של מנגה בידי מעריצים. זה מפר זכויות יוצרים, אך מסייע לפרסום מנגות שאינן מופצות רשמית מחוץ ליפן. כיום מו”לים מנסים לספק גרסאות דיגיטליות חוקיות כדי להפחית זאת.',
    },
    {
      id: 34,
      question: 'כיצד משפיעה הפופולריות של מנגה על ההחלטה להפוך אותה לאנימה?',
      answer:
        'אם המנגה מוכרת היטב (מכירות גבוהות, דירוג גבוה במגזינים), המפיקים רואים בה פוטנציאל. במקרים כאלה, סיכויי העיבוד לאנימה גדלים כדי לנצל את ההצלחה.',
    },
    {
      id: 35,
      question: 'מה הקשר בין דרמות טלוויזיה יפניות לבין מנגה ואנימה?',
      answer:
        "לפעמים מעבדים מנגה/אנימה ל'לייב-אקשן' (סדרת טלוויזיה או סרט עם שחקנים). דוגמאות: 'Rurouni Kenshin' או 'Attack on Titan'. דורש התאמות עלילה כדי להתאים לפורמט מצולם.",
    },
    {
      id: 36,
      question: 'מהי צנזורה באנימה ומדוע היא קיימת?',
      answer:
        'צנזורה מיושמת כאשר תכנים אלימים, מיניים או רגישים חורגים מכללי השידור ביפן או במדינות אחרות. חיתוכים, טשטושים ושינויים נועדו להתאים לשעות שידור או לרגולציות שונות.',
    },
    {
      id: 37,
      question:
        'כיצד משפיעים דירוגי גילאים (כמו PG-13, R-17) על ההפצה הבינלאומית של אנימה?',
      answer:
        'אנימות בעלות דירוג גבוה עלולות להיתקל בהגבלות בשידור לקהל צעיר. פלטפורמות או ערוצים מסוימים נמנעים משידור תוכן עם אלימות קשה או סצנות בוטות, או שמשדרים אותן בשעות מאוחרות בלבד.',
    },
    {
      id: 38,
      question: "מה זה 'סיינן מגזין' ו'שונן מגזין', וכיצד הם שונים?",
      answer:
        'אלו מגזינים יפניים המתמקדים בז’אנרים שונים של מנגה:\n• **שונן מגזין (Shonen Magazine)** – מיועד בעיקר לבני נוער צעירים ומכיל סיפורי הרפתקאות, פעולה וידידות (למשל *Weekly Shonen Jump* שבו פורסמו *Naruto* ו-*One Piece*).\n• **סיינן מגזין (Seinen Magazine)** – מיועד לקהל בוגר יותר עם סיפורים מורכבים יותר, נושאים בוגרים ואיורים מפורטים (כמו *Young Animal* שבו התפרסמה *Berserk*).',
    },
    {
      id: 39,
      question: 'איך מזהים איכות בימוי או עריכת סאונד טובה באנימה?',
      answer:
        "שמים לב לסנכרון בין מוזיקה/אפקטים קוליים לאירועי העלילה, לבחירת זוויות צילום, לקצב העריכה ולבניית האווירה. בימוי איכותי יגרום לצופה 'להרגיש' את הסצנה ולהישאב אליה.",
    },
    {
      id: 40,
      question: 'מהו תפקיד עוזרי המנגקה (Assistants) ביצירת מנגה?',
      answer:
        'עוזרים מתמקדים ברקעים, הצללות, הוספת פרטים קטנים וכו’, כדי שהמנגקה הראשי יוכל להשקיע בעיצוב הדמויות והעלילה. הם קריטיים במיוחד במנגות ארוכות, בעלות דדליין הדוק.',
    },
    {
      id: 41,
      question:
        'מהי הסיבה לצנזורה מחמירה יותר בגרסאות טלוויזיה לעומת גרסאות DVD/BD?',
      answer:
        'ערוצי טלוויזיה מחויבים לרגולציה קפדנית (שעות שידור, קהל היעד). במהדורות DVD/Blu-ray אפשר להציג את החומר המקורי ללא הצורך להתאים לכללי הרשתות, וכך להראות גרסה שלמה יותר.',
    },
    {
      id: 42,
      question:
        'כיצד משפיעים חוקי זכויות היוצרים ביפן על תהליך ייצור והפצת מרצ’נדייז?',
      answer:
        'במקרים רבים, זכויות הדמויות שייכות ליוצר/מו"ל/סטודיו, והם חותמים על הסכמי רישיון לחברות שמייצרות מרצ’נדייז. כל שינוי או עיצוב חדש מחייב אישור הרשויות המחזיקות בזכויות.',
    },
    {
      id: 43,
      question:
        "מה חשיבותו של 'Weekly Ranking' במגזינים כמו Shonen Jump לגבי המשך הסדרה?",
      answer:
        'בכל שבוע, קוראים מדרגים את המנגות האהובות. מנגה שזוכה למיקום נמוך לאורך זמן עלולה להסתיים מוקדם. אלה עם דירוג גבוה זוכות לפרסום רב, סיכוי גבוה יותר לעיבוד אנימה, ועוד.',
    },
    {
      id: 44,
      question: 'כיצד מעורבים תסריטאים (Scriptwriters) בעיבוד מנגה לאנימה?',
      answer:
        'הם מתאימים את צורת הסיפור למדיום הטלוויזיוני: מארגנים פרקי עלילה, כותבים דיאלוגים שמותאמים לזמן מסך ומחליטים מה לקצץ או להרחיב ביחס למנגה.',
    },
    {
      id: 45,
      question:
        'מדוע חלק מהיוצרים מעדיפים לפרסם מנגה במגזין דיגיטלי במקום פיזי?',
      answer:
        'פרסום דיגיטלי מאפשר גמישות בזמני העלאה, חסכוני בעלויות הדפסה, ומאפשר גישה מיידית לקהל עולמי. מגזינים דיגיטליים אף מודדים בקלות נתוני קריאה ושיתוף.',
    },
    {
      id: 46,
      question:
        'כיצד סטודיו אנימציה מחלק משימות בין אנימטורים בכירים (Key Animators), מעצבי רקעים וצבעים?',
      answer:
        'האנימטורים הבכירים מציירים את פריימי המפתח (Key Frames), אנימטורים זוטרים מוסיפים פריימים ביניים (In-Betweens), וצוותים ייעודיים מעצבים רקעים, אפקטים וצבע. כך מתחלק העומס בין מומחים בתחומם.',
    },
    {
      id: 47,
      question: "מה זה 'Genga' ו-'Douga' במסגרת יצירת אנימה?",
      answer:
        '* Genga (Key Animation) – ציורי הפריימים המרכזיים שמגדירים את התנועה.\n* Douga – הפריימים שביניהם (In-Betweens), המשמשים ליצירת אנימציה חלקה בין נקודות המפתח.',
    },
    {
      id: 48,
      question:
        "מהו 'Storyboard' (סטורי-בורד) באנימה וכיצד הוא מכתיב את קצב הסיפור?",
      answer:
        'הסטורי-בורד הוא רצף איורים סכמטי לכל סצנה, שמנחה את הבמאי והאנימטורים לגבי תזמון, זוויות צילום ועריכה. הוא קובע את הבסיס הוויזואלי לפני תחילת האנימציה המלאה.',
    },
    {
      id: 49,
      question:
        "האם אנימה עם 3D-CGI נחשבת לפחות 'מסורתית', והאם זה פוגע בפופולריות שלה?",
      answer:
        "לא בהכרח. יש הפקות 3D מצליחות מאוד ('Beastars', 'Land of the Lustrous'). הכל תלוי באיכות ה-CGI ובהשתלבותו בסגנון הציור. CGI ברמה נמוכה עלול להיתפס כמאולץ ולפגוע בחוויית הצפייה.",
    },
    {
      id: 50,
      question:
        'איך שומרים מנגה-קא על קצב יציב של צ’אפטרים (שבועיים/חודשיים) לאורך זמן?',
      answer:
        "לרוב בעזרת עוזרים (Assistants) וקפדנות בזמנים שמציב המגזין. לחץ העבודה גבוה מאוד. חלק מהיוצרים לוקחים הפסקות יזומות ('Hiatus') כשיש בעיות בריאות או צורך בארגון מחדש.",
    },
    {
      id: 51,
      question:
        'מה זה Production Committee וכיצד הוא מנווט את הבחירות הקריאטיביות באנימה?',
      answer:
        'ועדה המורכבת מכמה גופים (סטודיו, מו"ל, סוכנויות, משקיעים). היא מממנת את ההפקה בתמורה לזכויות מסוימות ומגדירה יעדי מכירות, סגנון רצוי ולוחות זמנים. לעיתים גם מתערבת בהחלטות תסריט ובחירת במאי.',
    },
    {
      id: 52,
      question:
        "כיצד 'Collaboration Cafés' (בתי קפה בהשראת אנימה) מסייעים בקידום הסדרה?",
      answer:
        'מקומות שבהם המנות, העיצוב והמרצ’נדייז מבוססים על האנימה. זה יוצר עניין תקשורתי, מפגשי מעריצים וקידום מכירות, ומעצים את תחושת הקהילה.',
    },
    {
      id: 53,
      question:
        "למה חלק מהיוצרים (כמו יושיהירו טוגאשי מ-'Hunter x Hunter') עושים הפסקות ארוכות בפרסום צ’אפטרים?",
      answer:
        'לעיתים עקב בעיות בריאות, לחץ נפשי או רצון לתכנן היטב את המשך העלילה. העדיפות היא לא לפגוע באיכות המנגה, ולכן העורך והמו"ל מאפשרים הפסקה.',
    },
    {
      id: 54,
      question: 'איך מעצבים שמות של דמויות ועולמות בסדרות פנטזיה יפניות?',
      answer:
        'חלק שואבים השראה ממיתולוגיה מערבית, חלק משתמשים בשמות יפניים עתיקים, וחלק ממציאים שפות מקוריות לחלוטין. המטרה היא להתאים את השם לאופי העולם ולתרבות שבונים.',
    },
    {
      id: 55,
      question:
        "מהי הסיבה להפקת 'רימייקים' (כמו 'Fruits Basket' החדש), והאם זה משקף מגמה בתעשייה?",
      answer:
        'רימייקים מאפשרים אנימציה מודרנית, נאמנות גדולה יותר למנגה (אם הגרסה הישנה סטתה), ומשיכת דור חדש של מעריצים. זו מגמה שמראה נכונות התעשייה לרענן כותרים פופולריים.',
    },
    {
      id: 56,
      question: 'כיצד מתנהל תהליך ליהוק המדבבים (Seiyuu Auditions) באנימה?',
      answer:
        'חברות הפקה והבמאי מקבלים דגימות קול, מזמנים מועמדים לאודישן ובוחרים את המתאים ביותר לדמות. סוכנויות קול גדולות מציגות את הטאלנטים שלהן, והבמאי קובע לבסוף מי ישתתף.',
    },
    {
      id: 57,
      question:
        "מה קורה כשהפקה של אנימה מחליפה סטודיו באמצע הסדרה (כמו 'One Punch Man' בין עונה 1 ל-2)?",
      answer:
        'ייתכן שינוי סגנון אמנות, ירידה/עלייה באיכות האנימציה, ומעבר של חלק מהצוות היצירתי או הבמאי. המעריצים לרוב רגישים לשינויים כאלה ומגיבים בהתאם ברשתות.',
    },
    {
      id: 58,
      question: 'איך מתבצע עיבוד Web Manga ארוכה לאנימה טלוויזיונית?',
      answer:
        'הצוות מעבד את הפורמט הדיגיטלי (Scrolling ארוך) למבנה פרקים של 24 דקות. לעיתים מקצרים/משמיטים חלקים, או משנים את הסדר, כדי לבנות סיפור מתאים לשידור שבועי.',
    },
    {
      id: 59,
      question:
        'האם לפעמים ארקים שלמים מקוצרים או מוסרים לגמרי בעיבוד אנימה ממנגה ארוכה?',
      answer:
        "כן. כדי לשמור על קצב מעניין או לעמוד במגבלות תקציב, המפיקים עשויים לדלג על 'ארקים צדדיים' או לקצר אותם, ולעיתים מוסיפים חומר חדש אם זה נחוץ.",
    },
    {
      id: 60,
      question:
        'מה ההבדל בין Artbook רשמי של יוצרי מנגה לבין אוסף סקיצות פרטי שלהם?',
      answer:
        'Artbook רשמי מציג לרוב איורים מוגמרים וצבעוניים שיועדו לפרסום, בעוד אוסף סקיצות חושף תהליכי עבודה מוקדמים, דוגמאות לא מאושרות ועיצובים שלא תמיד נכנסו לסיפור הסופי.',
    },
    {
      id: 61,
      question: 'מהם האתגרים בעיבוד מנגות אימה (Horror) לאנימה?',
      answer:
        'מעבר לאילוצי צנזורה, צריך לשלב סאונד, תאורה ואנימציה מתאימים כדי לשמור על אווירת פחד. עיבודים לא מוצלחים עלולים לאבד את אפקט האימה האמיתי של המנגה.',
    },
    {
      id: 62,
      question: "מה תפקידו של 'Chief Animation Director' בהפקת אנימה?",
      answer:
        'ה-Chief Animation Director מפקח על אחידות הסגנון והאיכות בכל הפרקים, מתקן איורים ומבטיח שהדמויות נראות אותו הדבר גם אם עובדים עליהן אנימטורים שונים. הוא חוליה חשובה בשרשרת האיכות.',
    },
    {
      id: 63,
      question:
        'מדוע חלק מהאנימות המצליחות לא זוכות לעיבוד קולנועי, בעוד שאחרות מקבלות כמה סרטים?',
      answer:
        "סרט קולנוע דורש תקציב עצום ועלילה סגורה. אם הסדרה לא נתפסת כ'שובר קופות' או שהעלילה לא מתאימה לעיבוד ארוך, המפיקים לא ייקחו סיכון. לפעמים גם היוצר מסרב או שיש מגבלות זכויות.",
    },
    {
      id: 64,
      question:
        'איך שינויי פסקול (Re-scoring) בגרסאות אמריקאיות/אירופיות של אנימה משפיעים על החוויה?',
      answer:
        'בעבר החליפו לעיתים את המוזיקה המקורית כדי להתאים לטעמו של הקהל המערבי, מה שלפעמים שינה את האווירה. כיום מעדיפים לשמור על פסקול המקורי מתוך כבוד ליוצר ולצופים המעריכים אותנטיות.',
    },
    {
      id: 65,
      question:
        "מה השיקולים המסחריים בהפקת סרט אנימה עלילתי מקורי (כמו 'Mugen Train' מ-'Demon Slayer')?",
      answer:
        'הצלחת הסדרה, פופולריות בינלאומית, והתאמת הארק לסרט קולנוע. כמו כן, סרט מגדיל מכירות כרטיסים, מרצ’נדייז ועניין ציבורי בסדרה.',
    },
  ],
  expert: [
    {
      id: 1,
      question: 'כיצד מוצאים מידע פנימי על הפקות אנימה עתידיות?',
      answer:
        '1. לעקוב אחר מגזינים יפניים (Weekly Shonen Jump).\n2. לבקר בכנסים גדולים (Anime Japan, Comiket).\n3. מעקב במדיה חברתית של הסטודיואים או מפיקים.\n4. לעיתים מתרחשות דליפות/שמועות בפורומים (Reddit, 2chan).',
    },
    {
      id: 2,
      question: 'מדוע חלק מהסדרות מסתיימות בלי סיום ברור או בלי עונה נוספת?',
      answer:
        '* ייתכן שלא הצליחו מסחרית.\n* התקרבו למנגה בלי תכנון פילרים.\n* בעיות זכויות או מעבר סטודיו.\n* הפסקה מהיוצר (בריאות/רצון אישי).',
    },
    {
      id: 3,
      question: 'איך מוודאים שצופים/קוראים תוכן חוקי ותומכים ביוצרים?',
      answer:
        '* צפייה בשירותי סטרימינג רשמיים (Crunchyroll, Funimation, Netflix).\n* רכישת מנגות רשמיות מודפסות או דיגיטליות.\n* קניית מרצ’נדייז רשמי.\n* הימנעות מצפייה פיראטית.',
    },
    {
      id: 4,
      question:
        'מדוע יש הבדלים גדולים בין סגנונות האנימציה של סטודיואים שונים?',
      answer:
        'כל סטודיו מעסיק במאים, מעצבים ואנימטורים בעלי סגנון ייחודי; חלק מרבים ב-CGI וחלק נשארים במסורת ידנית. במאים מובילים (כמו הייאו מיאזאקי ב-Ghibli) מכתיבים קו אמנותי אחיד.',
    },
    {
      id: 5,
      question: "מהו 'פנדום' (Fandom) וכיצד הוא משפיע על תעשיית האנימה?",
      answer:
        'פנדום הוא קהילת המעריצים של סדרה או ז’אנר. פעילות המעריצים (פאנארט, אירועי קוספליי, דיונים ברשת) מגדילה חשיפה ומכירות, מעודדת הפקות נוספות ומעודדת את המפיקים להשקיע במותג.',
    },
    {
      id: 6,
      question:
        'איך השוק הבין-לאומי משפיע על אופי ההפקות (Production Committee) ביפן?',
      answer:
        'הביקוש הגובר מחוץ ליפן גורם לוועדות הפקה להביא בחשבון את הטעם הבינלאומי, להרחיב הפצה בסטרימינג ולהפיק תכנים אוניברסליים יותר, אך עדיין לשמור על סגנון מקומי.',
    },
    {
      id: 7,
      question:
        'כיצד מתנהל משא ומתן על זכויות עיבוד בין סופרי לייט נובל/מנגה לסטודיואים?',
      answer:
        'הצדדים דנים במכירות, תחזיות רווח, זכויות מדיה (סרטים, סדרות, משחקים), ומגיעים להסכם על תמלוגים. ההוצאה לאור/הסוכן מייצגים את היוצר מול הסטודיו וחברות ההפקה.',
    },
    {
      id: 8,
      question:
        'האם יש שימוש בבינה מלאכותית בהפקות אנימה כיום, ואם כן באילו שלבים?',
      answer:
        'חלק מהסטודיואים משתמשים ב-AI להפקת רקעים בסיסיים, תיקוני פריימים או עיבוד צבע מהיר. עם זאת, רוב התעשייה עדיין נסמכת על עבודה ידנית איכותית, וה-AI משמש ככלי משלים.',
    },
    {
      id: 9,
      question:
        "מהן הסיבות לעיכובים בהוצאת פרקים (למשל בארקים גדולים כמו Wano ב-'One Piece')?",
      answer:
        '* לחץ בין הסטודיו למנגקה (שלא יקדים מדי את עלילת המנגה).\n* עומס פרויקטים לסטודיו.\n* בעיות בריאות של היוצר או הצוות.\n* אסטרטגיה שיווקית (יצירת מתח, הצפת המותג במרצ’נדייז).',
    },
    {
      id: 10,
      question:
        'איך נתוני צפייה ומכירות (Oricon, Blu-ray/DVD) משפיעים על עתיד הסדרה?',
      answer:
        'הם מדד להצלחה כלכלית. מכירות גבוהות או רייטינג מעולה מגדילים את הסיכוי להפקת עונה נוספת, סרטים או ספין-אופים. דירוגים משמשים כמשוב למפיקים ולסטודיו לתכנן קדימה.',
    },
    {
      id: 11,
      question:
        'כיצד שינויי מדיניות בערוצי טלוויזיה גדולים (MBS, Fuji TV וכו’) משפיעים על שעות השידור של אנימות?',
      answer:
        'אם הערוץ מעביר את האנימה ממשבצת לילה למשבצת בוקר, ייתכן שהתוכן יעבור צנזורה גדולה יותר או ישתנה קהל היעד. הדבר משפיע על הרייטינג, התקציב והסגנון של הסדרה.',
    },
    {
      id: 12,
      question:
        "למה לעיתים מפיקים משחררים 'פרקי ספיישל' (Special Episodes) או תוכניות Variety סביב האנימה?",
      answer:
        'כדי לקדם את הסדרה, לראיין שחקנים ומדבבים מפורסמים, לחשוף הצצות עתידיות או להוציא מאחורי הקלעים. זה מושך גם קהל שאינו צופה רגיל ומעלה מודעות למותג.',
    },
    {
      id: 13,
      question:
        'כיצד Crowdfunding (מימון המונים) תורם להפקת אנימות עצמאיות או ניסיוניות?',
      answer:
        'יוצרים עצמאיים יכולים לגייס ישירות מהמעריצים, בלי להיות תלויים בוועדות הפקה גדולות. כך ניתן להפיק פרויקטים נועזים או יוצאי דופן, אם הקהילה תומכת כלכלית.',
    },
    {
      id: 14,
      question: 'אילו צעדים ננקטים נגד פיראטיות באנימה, מלבד תביעות משפטיות?',
      answer:
        'שימוש ב-DRM בפלטפורמות סטרימינג, סימני מים (Watermarks) בקובצי וידאו, ושיתופי פעולה בין-לאומיים להסרת אתרים פיראטיים. בנוסף, מציעים חלופות חוקיות ומוזלות כדי לעודד צפייה חוקית.',
    },
    {
      id: 15,
      question:
        'איך Check Period של צנזורה ביפן יכול לעכב הוצאת פרקים, במיוחד בתוכן אלים או מורכב?',
      answer:
        'לפני השידור, גוף הרגולציה בודק את התוכן (למשל דם רב, תכנים מיניים בוטים). אם משהו חורג מהתקנים, ההפקה נאלצת לערוך מחדש את הסצנה, מה שמעכב את השידור.',
    },
    {
      id: 16,
      question: 'מהו תפקיד ה-Production Assistant (עוזר הפקה) בהפקת אנימה?',
      answer:
        'הוא מתאם בין המחלקות השונות (אנימציה, סאונד, עריכה), דואג ללוחות הזמנים, ומוודא שהכל יושלם בזמן ובאיכות הנדרשת על-ידי המפיקים והבמאי.',
    },
    {
      id: 17,
      question:
        'כיצד אירועי קד”ם (Promotional Events) באמריקה ובאירופה מגבירים את סיכויי ההצלחה של אנימה?',
      answer:
        'חשיפה בתערוכות וכנסים בינלאומיים יוצרת באזז עולמי, מביאה השקעות זרות ורכישת זכויות שידור. כך גדל הסיכוי לעונות המשך, סרטים או הפצת מרצ’נדייז רחבה יותר.',
    },
    {
      id: 18,
      question:
        'מהו היחס בין מנגה/אנימה לסדרות המבוססות על משחקי Visual Novel?',
      answer:
        "משחקי Visual Novel כוללים עלילות עם בחירות/סופים מרובים. בעיבוד לאנימה/מנגה צריך לבחור 'נתיב' עיקרי או לשלב חלקים מכמה סופים, וליצור עלילה אחידה שהצופים יוכלו לעקוב אחריה.",
    },
    {
      id: 19,
      question: 'כיצד עיצוב מנגה משפיע על פיסול דמויות ב-Scale Figures?',
      answer:
        "מעצבי הפיגרים מקפידים לשחזר בדיוק את פרטי הביגוד, התסרוקת והמבע הפנים. ככל שהעיצוב מורכב יותר, עולה מחיר הפיגר; פריטים נדירים הופכים ל'פיס היסטורי' בקרב אספנים.",
    },
    {
      id: 20,
      question:
        'מהם שלבי הפוסט-פרודקשן (Post-Production) העיקריים ביצירת אנימה?',
      answer:
        'לאחר סיום האנימציה והדיבוב, מגיע שלב העריכה הסופית: שילוב פסקול, אפקטים קוליים, כיוונון תאורה דיגיטלית (Compositing) ותיקונים אחרונים. רק אז הפרק מוכן לשידור או להפצה.',
    },
    {
      id: 21,
      question:
        "מה קורה לאיכות הסדרה כשהיא עוברת לסטודיו אחר בין עונות (כמו 'One Punch Man')?",
      answer:
        "ייתכן שינוי ניכר בסגנון האיורים, בקצב העבודה ובאיכות האנימציה. פעמים שזה מאכזב את הקהל אם מורגשת ירידה, ופעמים אחרות זה עשוי להביא לשיפור ולהזרמת 'דם חדש' להפקה.",
    },
    {
      id: 22,
      question:
        'מה ההבדל בין Web Manga למנגה מודפסת מסורתית, וכיצד זה משפיע על העיבוד לאנימה?',
      answer:
        'Web Manga מתפרסמת דיגיטלית (לרוב בפורמט גלילה ארוך). בהמרה לאנימה, לפעמים משנים את מבנה הסיפור, מארגנים מחדש את החלוקה לפרקים ומתאימים לטיימינג השבועי בטלוויזיה.',
    },
    {
      id: 23,
      question:
        'למה מפיקים מקצרים או מדלגים על ארקים שלמים כשמעבדים מנגה ארוכה?',
      answer:
        'הגבלות זמן ותקציב, או רצון להתמקד בארקים הפופולריים ביותר. לפעמים משאירים ארקים צדדיים לפורמטים אחרים (OAD, סרט סיכום או ספיישל).',
    },
    {
      id: 24,
      question:
        'איך נבדל Artbook רשמי מאוסף סקיצות (Rough Sketch Collection) של אותו יוצר?',
      answer:
        'Artbook כולל איורים מושקעים וקאנוניים שפורסמו רשמית; אוסף סקיצות חושף שלבי עבודה גולמיים, רעיונות מוקדמים או איורים אישיים שלא הופצו לקהל הרחב.',
    },
    {
      id: 25,
      question: 'מה האתגרים המרכזיים בעיבוד מנגת אימה (Horror) לאנימה?',
      answer:
        'מלבד צנזורה, יש צורך בטכניקות קול, תאורה ואנימציה שייצרו מתח ואימה אפקטיביים על המסך. תרגום סצנות אימה גרפיות למדיום מונפש עלול להיות מאתגר, והפקה לא מדויקת תאבד מהאפקט המצמרר.',
    },
    {
      id: 26,
      question:
        'מהי קהילת Sakuga וכיצד היא תורמת לדיון הציבורי על איכות האנימציה?',
      answer:
        'קהילת Sakuga מתמקדת בסצנות אנימציה מרשימות (Key Animation), מנתחת מי האנימטור האחראי, ומציפה מידע על הטכניקה והאיכות. כך עולה המודעות לאנימטורים ספציפיים ולייחוד הסגנוני של כל סטודיו.',
    },
    {
      id: 27,
      question:
        'כיצד חוקי זכויות היוצרים ביפן משפיעים על עיבודים, ספין-אופים ומרצ’נדייז של אנימה?',
      answer:
        'לרוב, המנגה-קא והמו”ל מחזיקים בזכויות, והם בוחרים אילו חברות יקבלו רישיון להפקות נלוות (משחקים, מרצ’נדייז). תהליך האישורים עלול להיות מורכב ולהגביל או לעודד יצירות נוספות.',
    },
    {
      id: 28,
      question:
        'מדוע יש אנימות פופולריות שלא עושות מעבר לקולנוע, בעוד אחרות מקבלות מספר סרטים?',
      answer:
        "תלוי בכדאיות מסחרית, התאמת העלילה למבנה קולנועי ושיקולים של מו”ל וסטודיו. אם קיים ארק קצר ומסעיר (כמו ב-'Demon Slayer'), הוא מתאים להפוך לסרט רווחי, בעוד אנימות אחרות פחות מתאימות.",
    },
    {
      id: 29,
      question:
        'כיצד שינויי פסקול (Re-scoring) משפיעים על הרגש והאווירה בגרסאות אנימה שמגיעות למערב?',
      answer:
        'מוזיקה משפיעה משמעותית על חוויית הצפייה. החלפת פסקול יפני במערבי עלולה לשנות את הטון ואת הקשר התרבותי, ולעיתים יוצרת ביקורת של מעריצים המעדיפים את המקור.',
    },
    {
      id: 30,
      question:
        "מה השיקולים המרכזיים להפקת סרט אנימה 'מקורי' (שאינו מסכם סיפור מהסדרה)?",
      answer:
        'אם יש רעיון עלילתי חדש המתאים לפורמט סרט, או ארק קצר שאפשר להרחיב לסרט מלא, ההפקה בוחרת להעלות אותו למסך הגדול. זה מאפשר אנימציה מושקעת, קד”מ נרחב והגדלת הרווחים ממכירות כרטיסים ומרצ’נדייז.',
    },
  ],
}

// קומפוננטה לשאלה ותשובה
function FAQItem({ id, question, answer, isOpen, onToggle }) {
  return (
    <div
      className="bg-secondaryBackground p-4 rounded-lg"
      style={{
        alignSelf: 'start',
        // הוספת סגנון גבול במידה והשאלה פתוחה
        ...(isOpen && {
          borderImage: `url(${images.redBorder}) 10 stretch`, // שימוש בתמונה כגבול
          borderWidth: '2px', // גודל הגבול
          borderStyle: 'solid', // חובה להגדיר solid כדי שהגבול יוצג
        }),
      }}
    >
      <div className="flex justify-between items-center">
        <p className="text-lg">{question}</p>
        <button onClick={onToggle}>
          <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center">
            {isOpen ? <MinusIcon /> : <PlusIcon />}
          </div>
        </button>
      </div>

      {/* מעטפת אנימציה עם max-height */}
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-80 pb-6' : 'max-h-0'
        }`}
      >
        <div className="mt-2 p-4 border-t border-gray-400">
          <p className='text-softText'>{answer}</p>
        </div>
      </div>
    </div>
  );
}


export function QuestionsAndAnswers() {
  // שמירת מצב פתוח עבור כל שאלה בתוך כל קטגוריה
  const [openQuestions, setOpenQuestions] = useState({})
  const imagesBanner = {
    beginners: faqImages.begginer,
    advanced: faqImages.advanced,
    almostexport: faqImages.advanced,
    expert: faqImages.expert,
  }

  // יצירת Refs דינמיים לכל קטגוריה
  const categoryRefs = useRef({
    beginners: null,
    advanced: null,
    expert: null,
  })

  // פתיחה/סגירה של שאלה לפי קטגוריה ו-ID
  const toggleQuestion = (category, id) => {
    setOpenQuestions((prev) => ({
      ...prev,
      [category]: prev[category] === id ? null : id, // מאפשר פתיחת אחת בלבד
    }))
  }

  // גלילה לקטגוריה הנבחרת
  const scrollToCategory = (category) => {
    categoryRefs.current[category]?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  // רשימת הקטגוריות
  const categories = [
    { key: 'beginners', label: 'מתחילים' },
    { key: 'advanced', label: 'מתקדמים' },
    { key: 'expert', label: 'מומחים' },
  ]

  return (
    <section className="container mx-auto">
      <FAQHelmet/>
      <div className="flex flex-col gap-12 mt-6">
        <h1 className="text-5xl text-center">שאלות נפוצות</h1>

        {/* כפתורים לגלילה מהירה */}
        <div className="flex flex-col gap-2">
          <span className="text-muted">קפוץ לשאלות ברמה שלך</span>
          <div className="flex gap-4">
            {categories.map((category) => (
              <button
                key={category.key}
                onClick={() => scrollToCategory(category.key)}
                className="w-[166px] h-[50px] hover:scale-105 transition-transform  text-softText"
                style={{
                  borderWidth: '2px', // עובי הגבול
                  borderStyle: 'solid', // חובה להגדיר סגנון גבול
                  borderImageSource: `url(${images.redBorder})`, // מקור תמונת הגבול
                  borderImageSlice: '20', // קובע חיתוך לתמונה
                  borderImageRepeat: 'stretch', // למתוח את התמונה כך שתמלא את הגבול
                }}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>

        {/* קטגוריות */}
        {categories.map((category) => (
          <div className="p-4" key={category.key}>
            {/* כותרת קטגוריה עם רקע תמונה לפי ה-key */}
            <div
              ref={(el) => (categoryRefs.current[category.key] = el)}
              className="relative flex items-center justify-center w-full h-[200px] mt-10"
              style={{
                // שימוש בתמונת הרקע מה- imagesBanner, ואם אין תמונה מוגדרת עבור הקטגוריה,
                // ניתן להשתמש בברירת מחדל (כגון faqImages.default)
                backgroundImage: `url(${imagesBanner[category.key] || faqImages.default})`,
                backgroundRepeat: 'no-repeat',   // מונע חזרה על התמונה
                backgroundSize: 'cover',       // אפשרות חלופית לשמירה על יחס הגובה-רוחב
              }}
            >
              <h2 className="text-3xl text-white relative z-10">
                {category.label}
              </h2>
            </div>

            {/* רשימת שאלות */}
            <div
              className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6"
              style={{ gridAutoRows: 'minmax(auto, max-content)' }}
            >
              {faqData[category.key].map(({ id, question, answer }) => (
                <FAQItem
                  key={id}
                  id={id}
                  question={question}
                  answer={answer}
                  isOpen={openQuestions[category.key] === id}
                  onToggle={() => toggleQuestion(category.key, id)}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
